/**
 * FLO-797: PostHog project 406762 is shared with flowtnow.com, and
 * `capture_exceptions` ingests every browser-extension and third-party throw
 * alongside ours. Ported from flowt-homepage's `src/lib/posthog.ts` so both
 * sites drop the same noise; keep the two lists in step when extending.
 */
import type { CaptureResult } from 'posthog-js';

/** Matched against the exception message. Extend as new noise is observed. */
const EXCEPTION_NOISE_PATTERNS: RegExp[] = [
  // Injected by certain browser extensions; seen across unrelated sites, with no
  // stack trace and a non-Error rejection value.
  /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/i,
];

/** `before_send` hook: drops known-noise `$exception` events, passes the rest. */
export function dropNoiseEvents(event: CaptureResult | null): CaptureResult | null {
  if (!event || event.event !== '$exception') return event;
  const list = (event.properties?.$exception_list ?? []) as Array<{ value?: string }>;
  const messages = list.map((e) => e?.value ?? '').join('\n');
  if (EXCEPTION_NOISE_PATTERNS.some((re) => re.test(messages))) return null;
  return event;
}
